"use strict";

require("animate.css/animate.min.css");